<div class="w-full flex items-center">
  <mat-form-field class="w-full" [appearance]="appearance" subscriptSizing="dynamic">
    <mat-label>
      <span *ngIf="!selectedJobId">Select job</span>
      <span *ngIf="selectedJobId">Job</span>
    </mat-label>
    <input data-cy="job-select" matInput [disabled]="!jobs?.length" [matAutocomplete]="autoComplete"
      [ngModel]="filterValue$ | async" (ngModelChange)="filterValue$.next($event)" [disabled]="disabled" />
    <mat-autocomplete data-cy="job-autocomplete" #autoComplete="matAutocomplete" panelWidth="auto">
      <mat-option *ngFor="let job of filteredJobs$ | async" [value]="job.name"
        (onSelectionChange)="select(job, $event)">
        {{ job.name }}
      </mat-option>
    </mat-autocomplete>
    <button matSuffix *ngIf="selectedJobId" mat-icon-button aria-label="Clear"
      (click)="clearJob.next(); filterValue$.next(null); $event.stopPropagation()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <button *ngIf="inactiveJobToggle" [color]="includeInactiveJobs ? 'primary' : ''" mat-icon-button
    matTooltip="Include inactive jobs"
    aria-label="Include inactive jobs" (click)="toggleIncludeInactiveJobs()">
    <mat-icon svgIcon="heroicons_outline:clock"></mat-icon>
  </button>
  <!--
  <mat-checkbox class="hidden xl:block" [(checked)]="includeInactiveJobs" (change)="includeInactiveJobsChanged($event)"
    [disabled]="disabled"><mat-label>Include inactive
      jobs</mat-label></mat-checkbox>
    -->
</div>